<template>
  <div>
    <mobile-navigation />
    <div class="Dashboard-wrapper">
      <sidebar-navigation />
      <router-view v-slot="{ Component }">
        <transition
          name="fade"
          mode="out-in"
        >
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>
<script>
import BaseModal from '@/components/modal/base-modal.vue';
import MobileNavigation from './mobile-navigation.vue';
import NavigationMenu from './sidebar-navigation.vue';

export default {
  components: {
    'sidebar-navigation': NavigationMenu,
    'mobile-navigation': MobileNavigation,
    BaseModal,
  },
  data() {
    return {
      modalOpen: true,
    };
  },
  mounted() {
    document.querySelector('body').classList.add('page-dashboard');
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";
$dashboardHeaderBreak: 1025px;
 .HeaderNotice.Notice {
    // margin: 105px 0 -100px 0;
      margin: 54px 0 -100px 0;

      @include customMediaQuery(min-width, $dashboardHeaderBreak) {
        margin: 0;
      }
    // @include respond-to(md) {
    //   margin: 0;
    // }
  }
  .FlashNotice {
      margin: 105px 0 0;
      @include respond-to(sm) {
        margin: 56px 0;
      }
      @include respond-to(md) {
        margin: 0;
      }
  }

.UserDashboard {
  @include respond-to(sm) {
    flex-basis: 100%;
  }

  h1 {
    color: red;
  }
}
.Dashboard-wrapper {
  position: relative;
  margin: 6rem 0 0 0;
  @media (min-width: 64em) {
    display: flex;
  }
}

.fade-enter-active{
  transition: opacity .2s;
}
.fade-leave-active {
  transition: opacity .2s;
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
